module.exports = __webpack_public_path__ + "static/media/logo.67d9dc9f.png";